import React from 'react';
import { BsTwitter } from 'react-icons/bs';
import { SiLinkedin } from 'react-icons/si';
import { BsYoutube } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
import Fade from 'react-reveal/Fade';

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <Fade left>
      <div className="footer-section-one">
        <div className="footer-logo-container">
          <h1 >earthly</h1>
        </div>
          <h6>Sustainable products at affordable prices</h6>
        <div className="footer-icons">
          <BsTwitter />
          <SiLinkedin />
          <BsYoutube />
          <FaFacebookF />
        </div>
      </div>
      </Fade>
      <Fade top>
      <div className="footer-section-two">
        <div className="footer-section-columns">
          <span>Qualtiy</span>
          <span>Help</span>
          <span>Share</span>
          <span>Careers</span>
          <span>Testimonials</span>
          <span>Work</span>
        </div>
        <div className="footer-section-columns">
          <span>244-5333-7783</span>
          <span>earthly@product.com</span>
          <span>sustainable@product.com</span>
          <span>contact@earthly.com</span>
        </div>
        <div className="footer-section-columns">
          <span>Terms & Conditions</span>
          <span>Privacy Policy</span>
        </div>
      </div>
      </Fade>
    </div>
  )
}

export default Footer